import script from "./widgetFreeTrial.vue?vue&type=script&lang=js"
export * from "./widgetFreeTrial.vue?vue&type=script&lang=js"

import "./widgetFreeTrial.vue?vue&type=style&index=0&id=5b1b51e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1b51e6"],['__file',"src/components/widgets/widgetFreeTrial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5b1b51e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5b1b51e6', __exports__)) {
    api.reload('5b1b51e6', __exports__)
  }
  
}


export default __exports__